module.exports = __webpack_public_path__ + "static/media/1POLICY33.bb9f946b.jpg";